<template>
  <svg
    :width="size * 1.54"
    :height="size"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.69124 16.1559C9.64724 16.1559 10.9552 14.9679 10.9552 11.9079C10.9552 8.97994 9.87524 7.88794 7.82324 7.88794C5.85524 7.88794 4.54724 9.06394 4.54724 12.1239C4.54724 15.0519 5.63924 16.1559 7.69124 16.1559ZM7.73924 14.8239C6.81524 14.8239 6.32324 14.2479 6.32324 12.0399C6.32324 9.85594 6.85124 9.21994 7.76324 9.21994C8.68724 9.21994 9.19124 9.79594 9.19124 11.9919C9.19124 14.1999 8.65124 14.8239 7.73924 14.8239Z"
      :fill="color"
    />
    <path d="M13.9969 15.9999V14.1759H12.2329V15.9999H13.9969Z" :fill="color" />
    <path
      d="M20.2628 8.04394H14.7068V9.54394H18.4628C17.1668 11.1519 16.1108 13.4799 15.4628 15.9999H17.5028C18.0548 13.4439 18.9908 11.1279 20.2628 9.37594V8.04394Z"
      :fill="color"
    />
    <path
      d="M20.9564 12.5079C21.2444 12.4599 22.0964 12.4239 22.6484 12.4239C24.0884 12.4239 24.7844 12.7359 24.7844 13.6599C24.7844 14.4519 24.3404 14.8599 23.5484 14.8599C22.7204 14.8599 22.3364 14.4759 22.4204 13.6839H20.6924C20.4284 15.3639 21.2804 16.1559 23.4044 16.1559C25.5644 16.1559 26.5484 15.1239 26.5484 13.5279C26.5484 11.7879 25.4444 11.1399 23.3324 11.1399C23.0804 11.1399 22.8044 11.1519 22.5524 11.1639L22.6844 9.54394H25.9964L26.1284 8.04394H21.2444L20.9564 12.5079Z"
      :fill="color"
    />
    <path
      d="M32.6789 9.90394H30.9389C30.7349 10.3239 30.5789 10.6719 30.4589 10.9719C30.2309 11.5119 30.0989 11.8839 30.0269 12.0879H30.0029C29.9069 11.7999 29.7629 11.4399 29.4869 10.8879L28.9109 9.80794L27.1109 9.91594L28.6589 12.8919L26.9789 15.9999H28.7309C28.9709 15.5319 29.1029 15.2199 29.3069 14.8119C29.5589 14.2479 29.7509 13.8039 29.7989 13.6239H29.8349C29.9069 13.8639 30.0269 14.1999 30.4109 14.9319L31.0469 16.1079L32.8469 15.9999L31.1789 12.7959L32.6789 9.90394Z"
      :fill="color"
    />
    <mask id="path-2-inside-1" fill="transparent">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      :fill="color"
    />
    <path
      d="M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z"
      :fill="color"
      mask="url(#path-2-inside-1)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
